import React, { useEffect, useState } from "react";
import { Box, Text, SimpleGrid, VStack, List, ListItem } from "@chakra-ui/react";
import * as api from "../api";
import { useAuth } from "../context/Auth.context";
import { useNavigate } from "react-router-dom";

const UpcomingAppointments = () => {
    const { user, isAuthed, ready } = useAuth();
    const navigate = useNavigate();
    const [appointments, setAppointments] = useState([]);
    const [message, setMessage] = useState("");

    useEffect(() => {
        if (ready && !isAuthed) {
            setMessage("Je moet ingelogd zijn om je afspraken te bekijken.");
            setTimeout(() => navigate("/login"), 2000);
        }
    }, [ready, isAuthed, navigate]);

    useEffect(() => {
        if (!user?.userId) return;

        api.get(`/appointments/user/${user.userId}/upcoming`)
            .then((res) => {
                const sorted = res.sort((a, b) =>
                    new Date(a.appointment_datetime) - new Date(b.appointment_datetime)
                );
                setAppointments(sorted);
            })
            .catch((err) => console.error("Fout bij ophalen van afspraken:", err));
    }, [user]);

    const formatDateTime = (isoString) => {
        const date = new Date(isoString);
        return `${date.toLocaleTimeString("nl-BE", {
            hour: "2-digit",
            minute: "2-digit",
        })}, ${date.toLocaleDateString("nl-BE")}`;
    };

    return (
        <Box maxW="1600px" mx="auto" mt="50px" p={5}>
            <Text fontSize="2xl" fontWeight="bold" textAlign="center" mb={8}>
                Toekomstige afspraken
            </Text>

            {!isAuthed ? (
                <Text color="red.500" textAlign="center">{message}</Text>
            ) : appointments.length === 0 ? (
                <Text color="gray.500" textAlign="center">Je hebt geen toekomstige afspraken.</Text>
            ) : (
                <SimpleGrid columns={{ base: 1, sm: 2, md: 3, lg: 4, xl: 5 }} spacing={5}>
                    {appointments.map((app) => (
                        <Box
                            key={app.appointmentId}
                            p={5}
                            bg="white"
                            boxShadow="md"
                            borderRadius="md"
                            width="100%"
                        >
                            <VStack align="start" spacing={2}>
                                <Text>
                                    <b>Datum en tijd:</b> {formatDateTime(app.appointment_datetime)}
                                </Text>
                                <Text>
                                    <b>Behandeling:</b> {app.treatmentName}
                                </Text>

                                {app.length_cm != null && (
                                    <Text>
                                        <b>Lengte:</b> {app.length_cm} cm
                                    </Text>
                                )}

                                {app.treatmentName !== 'Verwijdering tatoeage' &&
                                    app.treatmentOptions &&
                                    app.treatmentOptions.length > 0 && (
                                        <Box>
                                            <Text fontSize="sm" fontWeight="bold">Opties:</Text>
                                            <List spacing={1}>
                                                {app.treatmentOptions.map(opt => (
                                                    <ListItem key={opt.id}>
                                                        {opt.name} ({opt.quantity}x)
                                                    </ListItem>
                                                ))}
                                            </List>
                                        </Box>
                                    )}
                            </VStack>
                        </Box>
                    ))}
                </SimpleGrid>
            )}
        </Box>
    );
};

export default UpcomingAppointments;
